export default __webpack_public_path__ + "static/media/O-012.0d431949.png";